import { Navigate } from "react-router-dom";
import SignIn from "./pages/sign-in/sign-in";
import CreateAccountPage from './pages/create-account/create-account';
import SetupProfilePage from './pages/setup-profile';
import ConfirmAccountPage from './pages/confirm-account';
import ResetPasswordPage from "./pages/reset-password";
import SurveyResultsPage from "./pages/survey-results/survey-results.page";
import RTRPreviewPage from "./pages/view-survey/rtr-preview.page";
import DashboardPage from "./pages/dashboard/dashboard.page";
import GenerateSurvey from "./pages/generate-survey/generate-survey";
import TemplateScreen from "./pages/templates/template";
import CampaignReporterPage from "./pages/reports/campaign-reporter.page";
import CreateSurvey from "./pages/create-survey/create-survey";
import ProfileScreen from "./pages/profile";
import BillingPage from "./pages/billing/billing.page";
import PerformancePage from "./pages/performance/performance.page";
import ToolsPage from "./pages/tools/tools.page";
// import ViewSurvey from "./pages/view-survey";
import Layout from "./components/layout";
import Payment from "./pages/payment";
import TestLayoutPage from "./pages/test-layout/test-layout.page";
import ListSurveysScreen from "./pages/admin/survey-list.screen";
import SurveyCreateCsvScreen from "./pages/admin/survey-create-csv.screen";
import SurveyCreateScreen from "./pages/admin/survey-create.screen";
import SurveyDetailsScreen from "./pages/admin/survey-details.screen";
import ListAudienceScreen from "./pages/admin/audience-list.screen";
import AudienceCreateScreen from "./pages/admin/audience-create.screen";
import ListDiscoveriesScreen from "./pages/admin/discovery-list.screen";
import DiscoveriesCreateScreen from "./pages/admin/discovery-create.screen";
import SurveyReviewScreen from "./pages/admin/survey-review.screen";
import Four04 from "./pages/404";
import ReportsPage from "./pages/reports/reports.page";
import EmailSignInPage from "./pages/email-sign-in/email-sign-in.page";
import ClientManagementPage from "./pages/client-management/client-management.page";

export interface RouterProps {
  path: string;
  element: React.ReactNode;
  guard: 'isAuthenticated' | 'isSuperAdmin' | 'isOrg' | 'isClient' | 'none';
  redirect?: string;
}


const ROUTES: RouterProps[] = [
  {
    path: '/',
    element: (
      <Navigate
        to="/login"
        replace
      />),
    guard: 'none',
  },
  {
    path: '/login',
    element: <SignIn />,
    guard: 'none',
  },
  {
    path: '/auth/email/:uuid',
    element: <EmailSignInPage />,
    guard: 'none',
  },
  {
    path: '/create-account',
    element: <CreateAccountPage />,
    guard: 'none',
  },
  {
    path: '/setup-profile',
    element: <SetupProfilePage />,
    guard: 'none',
  },
  {
    path: '/confirm-account',
    element: <ConfirmAccountPage />,
    guard: 'none',
  },
  {
    path: '/auth/reset-password/:uuid',
    element: <ResetPasswordPage />,
    guard: 'none',
  },
  {
    path: '/share-survey',
    element: <SurveyResultsPage />,
    guard: 'none',
  },
  {
    path: '/share-rtr',
    element: <RTRPreviewPage />,
    guard: 'none',
  },
  // {
  //   path: '/client/dashboard',
  //   element: <ClientDashboard />,
  //   guard: 'isClient',
  //   redirect: '/login',
  // },
  {
    path: '/client/reports-old',
    element: <CampaignReporterPage />,
    guard: 'isClient',
    redirect: '/login',
  },
  // {
  //   path: '/client/reports',
  //   element: <ClientReportsPage />,
  //   guard: 'isClient',
  //   redirect: '/login',
  // },
  {
    path: '/dashboard',
    element: <DashboardPage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/generate-survey',
    element: <GenerateSurvey />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/templates',
    element: <TemplateScreen />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/reports',
    element: <ReportsPage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/reports-old',
    element: <CampaignReporterPage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/create-survey',
    element: <CreateSurvey />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/account',
    element: <ProfileScreen />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/billing',
    element: <BillingPage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/performance',
    element: <PerformancePage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/tools',
    element: <ToolsPage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/manage-clients',
    element: <ClientManagementPage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/view-survey',
    element: <SurveyResultsPage />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/admin',
    element: <Layout />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/payment',
    element: <Payment />,
    guard: 'isOrg',
    redirect: '/login',
  },
  {
    path: '/test-layout',
    element: <TestLayoutPage />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/surveys',
    element: <ListSurveysScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/surveys/csv',
    element: <SurveyCreateCsvScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/surveys/bulk-create',
    element: <SurveyCreateScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/surveys/:id',
    element: <SurveyDetailsScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/audiences',
    element: <ListAudienceScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/audiences/create',
    element: <AudienceCreateScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/discoveries',
    element: <ListDiscoveriesScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/discoveries/create',
    element: <DiscoveriesCreateScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/review',
    element: <SurveyReviewScreen />,
    guard: 'isSuperAdmin',
    redirect: '/login',
  },
  {
    path: '/*',
    element: <Four04 />,
    redirect: '/login',
    guard: 'none',
  },
];

export default ROUTES;